import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const formikPropType = PropTypes.shape({
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
});

export const joyn2UserPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
});
